import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TbPhotoStar, TbTrash } from 'react-icons/tb';

import { Spinner } from '@/components/atoms/Spinner';

type Props = {
  pictureId: string;
  isLoading: boolean;
  alreadyMainPicture?: boolean;
  handleSetPictureAsMain: (pictureId: string) => void;
  handleDeletePictureRestaurant: (pictureId: string) => void;
  thereIsNoCertificate?: boolean;
};

export const PictureMenuItem: FC<Props> = ({
  pictureId,
  isLoading,
  handleSetPictureAsMain,
  handleDeletePictureRestaurant,
  alreadyMainPicture = false,
  thereIsNoCertificate
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1 mt-2 h-full">
      {!alreadyMainPicture && (
        <button
          disabled={isLoading || thereIsNoCertificate}
          onClick={() => handleSetPictureAsMain(pictureId)}
          className="hover:cursor-pointer h-fit disabled:cursor-not-allowed text-xs flex gap-2 hover:border-primary duration-200 w-full justify-center ease-in-out hover:text-primary px-2 py-1.5 md:py-2 border rounded-lg  hover:bg-shades-primary-active/30 items-center border-gray-300 text-black"
        >
          {isLoading ? <Spinner reverse={true} /> : <TbPhotoStar className="text-lg" />} {t('subMenu.setAsMain')}
        </button>
      )}
      <button
        disabled={isLoading || alreadyMainPicture || thereIsNoCertificate}
        onClick={() => handleDeletePictureRestaurant(pictureId)}
        className="hover:cursor-pointer h-fit disabled:cursor-not-allowed text-xs flex gap-2 hover:border-red-800 duration-200 w-full justify-center ease-in-out hover:text-white px-2 py-1.5 md:py-2 border rounded-lg  hover:bg-red-500 items-center border-gray-300 text-black"
      >
        {isLoading ? <Spinner reverse={true} /> : <TbTrash className="text-lg" />}
        {t('subMenu.deletePicture')}
      </button>
    </div>
  );
};
